import template from './trip-traveller-allocation-passenger.html';
import tripEvents from 'modules/trip/config/events.constant';

const DIRECTIVE_NAME = TripTravellerAllocationPassenger.DIRECTIVE_NAME = 'ktTripTravellerAllocationPassenger';
export default function TripTravellerAllocationPassenger() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: TripTravellerAllocationPassengerController,
        controllerAs: '$ctrl',
        scope: {
            traveller: `=${DIRECTIVE_NAME}`,
            travellers: `=${DIRECTIVE_NAME}Travellers`,
            tripDetails: `=${DIRECTIVE_NAME}TripDetails`,
            flight: `=${DIRECTIVE_NAME}Flight`,
            recommendation: `=${DIRECTIVE_NAME}Recommendation`,
            isExpanded: `=${DIRECTIVE_NAME}IsExpanded`,
            selectedSeats: `=${DIRECTIVE_NAME}SelectedSeats`,
            isFirst: `=${DIRECTIVE_NAME}IsFirst`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function TripTravellerAllocationPassengerController(
    $scope,
    userService,
    tripTravellerAllocationPassengerService,
    tripTravellerAllocationService,
    selectedSeatsService,
    discardSeatOnTravellerChangeService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        userIsGoingToSelectASeat,
        saveSelectedSeats,
    });

    function $onInit() {
        vm.rs = userService.getRegionalSettings();
        $scope.$watch(() => vm.traveller, () => {
            initTravellerInformation();
            initializeTravellingWithInfant();
        }, true);

        initializeOrderNumber();
        initializeFFNsWatcher();

        $scope.$watch(
            () => vm.selectedSeats,
            () => {
                vm.selectedSeat = selectedSeatsService.getSelectionModel(vm.traveller, vm.flight, vm.selectedSeats);
            },
        true);
    }

    function initTravellerInformation() {
        vm.fullName = tripTravellerAllocationPassengerService.getTravellerFullName(vm.traveller);
        vm.isChild = tripTravellerAllocationPassengerService.isChild(vm.traveller);
    }

    function saveSelectedSeats(selectedSeats) {
        vm.selectedSeats = selectedSeats;
        const flightId = vm.flight.Id;

        if (!(selectedSeats && selectedSeats[flightId])) {
            return;
        }

        const currentFlightSelectedSeats = {
            [flightId]: selectedSeats[flightId],
        };
        tripTravellerAllocationService.saveSeats(currentFlightSelectedSeats)
            .then(() => $scope.$emit(tripEvents.TRIP_UPDATE_COSTS));
    }

    function initializeFFNsWatcher() {
        $scope.$watch(() => vm.traveller, initializeHasTravellerChanged, true);
        $scope.$watch(() => vm.traveller.ClubCards, initializeFFNs, true);
        $scope.$watch(() => vm.selectedFFN, onFrequentFlyerNumberSelect);
    }

    function initializeHasTravellerChanged(newValue, oldValue) {
        vm.hasTravellerChanged = discardSeatOnTravellerChangeService.hasTravellerInformationBeenChanged(newValue, oldValue);
    }

    function initializeFFNs() {
        vm.areFFNsProvided = tripTravellerAllocationPassengerService.areFFNsProvided(vm.traveller);
        vm.FFNsList = tripTravellerAllocationPassengerService.getFFNsListForDropdown(vm.traveller);
        vm.selectedFFN = tripTravellerAllocationPassengerService.preSelectFFN(
            vm.FFNsList,
            vm.flight,
            vm.traveller,
            vm.selectedSeats
        );
        updateSelectedSeatWithFfn();
    }

    function onFrequentFlyerNumberSelect(newValue, oldValue) {
        const haveWeChangedFfn = newValue && oldValue && newValue.value !== oldValue.value;
        if (!haveWeChangedFfn) {
            return;
        }

        if (vm.hasTravellerChanged) {
            vm.hasTravellerChanged = false;
            return;
        }

        vm.isDiscardMessageVisible = selectedSeatsService.isSeatSelectedForTraveller(vm.selectedSeat);
        vm.selectedSeats = selectedSeatsService.deselectSeat(
            vm.selectedSeats,
            vm.traveller,
            vm.flight
        );
        updateSelectedSeatWithFfn();
        saveSelectedSeats(vm.selectedSeats);
    }

    function updateSelectedSeatWithFfn() {
        vm.selectedSeats = selectedSeatsService.selectSeatFFN(
            vm.selectedFFN,
            vm.selectedSeats,
            vm.flight,
            vm.traveller
        );
    }

    function initializeTravellingWithInfant() {
        const infant = tripTravellerAllocationPassengerService.getInfantThisPassengerTravellingWith(
            vm.traveller,
            vm.tripDetails
        );
        if (!infant) {
            return;
        }
        vm.travellingWithInfant = tripTravellerAllocationPassengerService.getTravellerFullName(infant);
    }

    function initializeOrderNumber() {
        vm.orderNumber = tripTravellerAllocationPassengerService.getTravellerOrderNumberAmongAll(
            vm.traveller,
            vm.travellers,
        );
    }

    function userIsGoingToSelectASeat() {
        vm.isDiscardMessageVisible = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation-segment/trip-traveller-allocation-flight/trip-traveller-allocation-passenger/trip-traveller-allocation-passenger-component.js